import * as React from 'react';
import { clsx } from 'clsx';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { ButtonLink } from '../ButtonLink';
import * as styles from './ToggleButton.css';

export interface IToggleButtonProps {
  children: React.ReactNode;
  isOpened: boolean;
  onClick(e: React.MouseEvent<HTMLElement>): void;
}

export function ToggleButton({ children, isOpened, onClick }: IToggleButtonProps): React.JSX.Element {
  return (
    <ButtonLink onClick={onClick}>
      {children}&nbsp;
      <span className={clsx(styles['icon'], isOpened && styles['icon--opened'])}>
        <IconActionChevronDownSmall16 color="icon-main-default" display="inline-block" />
      </span>
    </ButtonLink>
  );
}
